module.exports = __webpack_public_path__ + "img/logo.a94a1eae.svg";